import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: -${({ spacing }) => spacing};

  > div,
  > article,
  > a {
    margin: ${({ spacing }) => spacing};
    width: calc(100% - (${({ spacing }) => spacing} * 2));

    a {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &.columns-5 {
    align-items: center;
    > div,
    > article,
    > a {
      flex: 16%;
    }
  }
  
  &.episode-columns {
    align-items: center;
  }
  
  @media only screen and (min-width: ${themeGet(
    'breakpoints.md'
  )}) and (max-width: calc(${themeGet('breakpoints.lg')} - 1px)) {
    &.columns-4 {
      flex-direction: row;

      > div,
      > article,
      > a {
        /* Width of each card is equal to 100% width / amount of cards per row - (margin * 2) as we want to subtract it equally from both sides */
        width: calc((100% / 2) - (${({ spacing }) => spacing} * 2));

        @supports (-ms-ime-align: auto) {
          /* Fixes Edge */
          /* width: calc((100% / 2) - (${({ spacing }) =>
            spacing} * 2) - 1px); */
        }
      }
    }

    &.columns-4.regular-columns {
      flex-direction: column;
      
      > div,
      > article,
      > a {
        width: calc(100% - (${({ spacing }) => spacing} * 2));
      }
    }

    &.columns-5 {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      > div,
      > a {
        flex: 50%;
      }
    }

    &.episode-columns{
      justify-content: center;
      flex-direction: row;
    }
  }
  }
  
  /* Feature, Blog, and product card styling after tablet */
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;

    > div,
    > article,
    > a {
      /* Width of each card is equal to 100% width / amount of cards per row - (margin * 2) as we want to subtract it equally from both sides */
      width: calc(
        (100% / ${({ columns }) => columns}) - (${({ spacing }) => spacing} * 2)
      );

      @supports (-ms-ime-align: auto) {
        /* Fixes Edge */
        width: calc(
          (100% / ${({ columns }) => columns}) -
            (${({ spacing }) => spacing} * 2) - 1px
        );
      }
    }
  }

  /* Fixes IE for feature and blog cards */
  @media only screen and (min-width: ${themeGet(
    'breakpoints.md'
  )}) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    > div,
    > article,
    > a {
      width: calc(
        (100% / ${({ columns }) => columns}) - (${({ spacing }) =>
  spacing} * 2) -
          1px
      );
    }
  }
`;
